import { render, staticRenderFns } from "./SelectShippingAddress.vue?vue&type=template&id=1bb7158e&"
import script from "./SelectShippingAddress.vue?vue&type=script&lang=js&"
export * from "./SelectShippingAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports